import EnterCode from '@/components/auth/enter-code';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/enter-code')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EnterCode />;
}
